import Button from "components/Button";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";
import { NavbarProps } from "./types";

export const getBoxShadow = ({ showBoxShadow }: NavbarProps) => {
    if (showBoxShadow) {
        return css`
            box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
        `;
    }
};

export const ActiveLinkStyles = (isActive: boolean) => {
    if (isActive) {
        return css`
            opacity: 1;
            color: ${colors.purple.primary};
            &:after {
                left: 0;
                width: 100%;
            }
        `;
    }
};

export const NavbarWrapper = styled.div<{
    hidden?: boolean;
    backgroundColor?: string;
    showBoxShadow?: boolean;
}>`
    width: 100%;
    position: fixed;
    z-index: 10999;
    ${({ backgroundColor }) =>
        backgroundColor &&
        css`
            background-color: ${backgroundColor};
        `};

    ${getBoxShadow};
    grid-area: header;
    ${({ hidden }) =>
        hidden &&
        css`
            display: none;
        `}
`;
export const InnerWrapper = styled.div`
    width: 100%;
    display: flex;
    padding: 16px 14px;
    position: relative;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    z-index: 5;
`;

export const UserProfileWrapper = styled.div`
    position: relative;
`;

export const NavIcon = styled.img`
    height: 30px;
    cursor: pointer;
    @media only screen and (max-width: 550px) {
        height: 20px;
    }
`;

export const NavLinks = styled.div`
    display: flex;
    align-items: center;
    gap: 50px;

    ${Button.Style} {
        visibility: hidden;
    }

    @media only screen and (max-width: 1160px) {
        gap: 20px;
    }
    @media only screen and (max-width: 1000px) {
        display: none;
    }
`;

export const NavLink = styled(Link)<{ isActive: boolean }>`
    text-decoration: none;
    font-weight: 600;
    color: ${colors.grey.dark};
    font-family: "Montserrat", sans-serif;
    opacity: 0.8;
    transition: opacity 0.3s;
    position: relative;
    &:hover {
        opacity: 1;
        color: ${colors.purple.primary};
        text-decoration: none;
    }
    &:after {
        bottom: -31px;
        content: "";
        display: block;
        height: 5px;
        left: 50%;
        position: absolute;
        background: ${colors.purple.primary};
        border-radius: 5px;
        transition: width 0.3s ease 0s, left 0.3s ease 0s;
        width: 0;
    }
    &:hover::after {
        left: 0;
        width: 100%;
    }
    ${({ isActive }) => ActiveLinkStyles(isActive)};
`;

export const RightSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2vw;
    margin-right: 2rem;
`;

export const Count = styled.span``;

export const CountCircle = styled.div`
    display: inline-block;
    position: absolute;
    height: 12px;
    width: 12px;
    top: 0;
    right: 0;
`;

export const CountBg = styled.div`
    position: relative;
    border-radius: 50%;
    background-color: #00bbc7;
    width: 100%;
    height: 100%;
    ${Count} {
        font-size: 8px;
        color: #fff;
        font-weight: 600;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const Icon = styled.div`
    position: relative;
    cursor: pointer;
    visibility: hidden;
`;

export const SearchbarSection = styled.div`
    display: flex;
    align-items: center;
    gap: 1.5rem;
    visibility: hidden;
`;

export const MobileNavbar = styled.div<{
    innerWrapperHeight: number;
    isMobileNavOpen: boolean;
}>`
    color: #fff;
    width: 100%;
    position: fixed;
    transition: transform 0.3s ease-in-out 0s;
    transform: ${({ isMobileNavOpen }) =>
        isMobileNavOpen ? "translate(0)" : "translate(100%)"};
    min-height: 100vh;
    top: 0;
    padding: 20px;
    padding-top: ${({ innerWrapperHeight }) => `${innerWrapperHeight}px`};
    z-index: 1;
    background: linear-gradient(115.7deg, #6854f6 0%, #834cee 100%);
`;

export const UserSection = styled.div`
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 14px rgba(136, 104, 234, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
`;

export const UserInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    div:first-of-type {
        padding: 0;
        gap: 6px;
    }
`;

export const UserPic = styled.img`
    border-radius: 50%;
    width: 70px;
    height: 70px;
    border: 1px solid #fff;
`;

export const MobileNavLink = styled.a`
    text-decoration: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 30px;
`;

export const NumberIcon = styled.div`
    width: 16px;
    height: 16px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
`;

export const HorizontalSeparator = styled.div`
    width: 100%;
    opacity: 0.2;
    height: 1px;
    background-color: #efefef;
    margin: 30px 0;
`;

export const NavLinkLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 11px;
`;

export const AuthButton = styled(Link)`
    padding: 12px 25px 12px 25px;
    border-radius: 40px;
    border: 1.5px;
    gap: 50px;
    border: 1px solid ${theme.colors.white};
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    color: ${theme.colors.white};
    cursor: pointer;
    transition: ease 0.3s;
    text-decoration: none;

    &:hover {
        color: rgba(255, 255, 255, 0.8);
        border-color: rgba(255, 255, 255, 0.8);
    }
`;

export const Nav = styled.nav``;

export const NavList = styled.ul`
    display: flex;
    align-items: center;
    gap: 1.2rem;
`;

export const NavItem = styled.li`
    @media (${theme.breakpoints.tabletL}) {
        display: none;
    }
`;

export const HomeLink = styled(Link)`
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    cursor: pointer;
    transition: ease 0.3s;
    text-decoration: none;
    color: ${theme.colors.white};

    &:hover {
        color: rgba(255, 255, 255, 0.8);
    }
`;
